import dayjs from "dayjs";
import { useEffect, useReducer, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { useAppStore } from "./store/app.store";
import ErrorUnexpectedScreen from "./ui/components/pages/ErrorUnexpectedScreen/ErrorUnexpectedScreen";
import Spinner from "./ui/components/utils/Spinner/Spinner";
import buildAppRouter from "./ui/providers/app-auth/router";
import { eventBus } from "./ui/shared/global-tools/event-bus";
import { showToast } from "./ui/shared/global-tools/toast-system";
import { getUrlParameter } from "./ui/shared/global-tools/url-parameters";

export default function AppRoot() {
  const isDesktopMode = window.matchMedia("(min-width: 992px)").matches;
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [errorMessage, setErrorMessage] = useState<string>();
  const setAppLayout = useAppStore((state) => state.setAppLayout);

  useEffect(() => {
    const authFailed = getUrlParameter("auth");
    if (authFailed === "failed") {
      showToast("Vous n'êtes pas autorisé à vous connecter", { severity: "info", sticky: false });
      return;
    }
  }, []);

  useEffect(() => {
    dayjs.locale("fr");
    eventBus.on("fatalError", setErrorMessage);
    eventBus.on("globalRepaint", forceUpdate);
    return () => {
      eventBus.off("fatalError", setErrorMessage);
      eventBus.off("globalRepaint", forceUpdate);
    };
  }, []);

  useEffect(() => {
    setAppLayout(isDesktopMode ? "desktop" : "mobile");
  }, [isDesktopMode]);

  if (errorMessage) return <ErrorUnexpectedScreen message={errorMessage} />;

  return <RouterProvider fallbackElement={<Spinner />} router={buildAppRouter()} />;
}
